import React, { Component } from "react";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import SimpleInput from "../../../../modules/SimpleInput";
import FlexView from "react-flexview";
import SimpleDate from "../../../../modules/SimpleDate";
import moment from "moment";
import SimpleDDL from "../../../../modules/SimpleDDL";
import { BOOKING_STATUS_OPTIONS } from "../config";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import { removeNullFields } from "../../../common/mapper";

class ManagementBookingFilter extends Component {
  constructor(props) {
    super(props);
    this.initialFormData = {
      customerName: null,
      plateNumber: null,
      waHPNumber: null,
      startBookingDate: null,
      endBookingDate: null,
      bookingStatus: null,
    };
    this.state = {
      formData: this.initialFormData,
    };
  }

  componentDidMount() {
    if (this.props.submitedFilter) {
      this.setState({ formData: this.props.submitedFilter });
    }
  }

  handleSetValue = (name, value) => {
    this.setState((prev) => ({
      ...prev,
      formData: {
        ...prev.formData,
        [name]: value,
      },
    }));
  };

  handleReset = () => {
    this.setState({ formData: this.initialFormData });
  };

  handleSubmit = () => {
    const payload = removeNullFields({
      ...this.state.formData,
      bookingStatus: this.state.formData?.bookingStatus?.value || null,
    });
    this.props.onSubmitFilter(payload);
    this.props.onClickClose();
  };

  render() {
    const { visible, onClickClose } = this.props;
    const { formData } = this.state;
    return (
      <SimpleModal
        visible={visible}
        title="Detail Manajemen Booking"
        onClickClose={() => onClickClose()}
        content={
          <ModalContainer>
            <SimpleInput
              id="input_customer_name"
              name="customerName"
              value={formData.customerName}
              label="Nama Customer"
              onChange={({ target }) =>
                this.handleSetValue(target.name, target.value)
              }
            />
            <p className="margin margin-bottom-15px">Tanggal Booking</p>
            <FlexView vAlignContent="center" style={{ gap: "10px" }}>
              <div className="flex-1">
                <SimpleDate
                  id="select_start_date"
                  name="startBookingDate"
                  nextdate
                  containerclassname="width width-280px"
                  date={formData.startBookingDate}
                  maxDate={formData.endBookingDate}
                  onChange={(value) =>
                    this.handleSetValue(
                      "startBookingDate",
                      moment(value).format("DD-MM-YYYY")
                    )
                  }
                />
              </div>
              <p className="margin margin-bottom-15px">s/d</p>
              <div className="flex-1">
                <SimpleDate
                  id="select_endDate"
                  name="endBookingDate"
                  backdate
                  containerclassname="width width-280px"
                  date={formData.endBookingDate}
                  minDate={formData.startBookingDate}
                  onChange={(value) =>
                    this.handleSetValue(
                      "endBookingDate",
                      moment(value).format("DD-MM-YYYY")
                    )
                  }
                />
              </div>
            </FlexView>
            <SimpleInput
              id="input_no_wa"
              name="waHPNumber"
              value={formData.waHPNumber}
              label="No WA/HP"
              onChange={({ target }) =>
                this.handleSetValue(target.name, target.value)
              }
            />
            <SimpleInput
              id="input_customer_name"
              name="plateNumber"
              value={formData.plateNumber}
              label="Nomor Plat"
              onChange={({ target }) =>
                this.handleSetValue(target.name, target.value)
              }
            />
            <SimpleDDL
              box="search"
              label="Status"
              name="bookingStatus"
              options={BOOKING_STATUS_OPTIONS}
              value={formData?.bookingStatus}
              onChange={(value, { name }) => this.handleSetValue(name, value)}
            />
            <FlexView style={{ justifyContent: "flex-end" }}>
              <FlexView vAlignContent="center" style={{ gap: "15px" }}>
                <SimpleButton text="HAPUS" onClick={this.handleReset} />
                <SimpleButton text="TERAPKAN" onClick={this.handleSubmit} />
              </FlexView>
            </FlexView>
          </ModalContainer>
        }
      />
    );
  }
}

export default ManagementBookingFilter;
